import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1a1a1a", // Dark black
      light: "#333333",
      dark: "#000000",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#174a82", // Dark blue
      light: "#42a5f5",
      dark: "#0d47a1",
      contrastText: "#ffffff",
    },
  },
});

export default theme;
